export var Variant;
(function (Variant) {
  Variant["Default"] = "Default";
  Variant["Compact"] = "Compact";
  Variant["WithBackdrop"] = "With backdrop";
  Variant["WithBackdropAndMedia"] = "With backdrop and media";
})(Variant || (Variant = {}));
export var CopyVariant;
(function (CopyVariant) {
  CopyVariant["Default"] = "Default";
  CopyVariant["Expressive"] = "Expressive";
})(CopyVariant || (CopyVariant = {}));
export var BackdropLayout;
(function (BackdropLayout) {
  BackdropLayout["Vertical"] = "Vertical";
  BackdropLayout["Horizontal"] = "Horizontal";
})(BackdropLayout || (BackdropLayout = {}));
export var MediaType;
(function (MediaType) {
  MediaType["Image"] = "Image";
  MediaType["LottieAnimation"] = "Lottie animation";
})(MediaType || (MediaType = {}));